/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReferralDocumentInput
 */
export interface ReferralDocumentInput {
    /**
     * 
     * @type {number}
     * @memberof ReferralDocumentInput
     */
    document_id: number;
    /**
     * 
     * @type {string}
     * @memberof ReferralDocumentInput
     */
    document_type?: string;
    /**
     * 
     * @type {string}
     * @memberof ReferralDocumentInput
     */
    file_name: string;
    /**
     * 
     * @type {string}
     * @memberof ReferralDocumentInput
     */
    s3_key: string;
    /**
     * 
     * @type {string}
     * @memberof ReferralDocumentInput
     */
    content_type: string;
    /**
     * 
     * @type {number}
     * @memberof ReferralDocumentInput
     */
    file_size_bytes: number;
    /**
     * 
     * @type {number}
     * @memberof ReferralDocumentInput
     */
    page_count?: number;
    /**
     * 
     * @type {string}
     * @memberof ReferralDocumentInput
     */
    original_document_hash?: string;
}

/**
 * Check if a given object implements the ReferralDocumentInput interface.
 */
export function instanceOfReferralDocumentInput(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "document_id" in value;
    isInstance = isInstance && "file_name" in value;
    isInstance = isInstance && "s3_key" in value;
    isInstance = isInstance && "content_type" in value;
    isInstance = isInstance && "file_size_bytes" in value;

    return isInstance;
}

export function ReferralDocumentInputFromJSON(json: any): ReferralDocumentInput {
    return ReferralDocumentInputFromJSONTyped(json, false);
}

export function ReferralDocumentInputFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReferralDocumentInput {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'document_id': json['document_id'],
        'document_type': !exists(json, 'document_type') ? undefined : json['document_type'],
        'file_name': json['file_name'],
        's3_key': json['s3_key'],
        'content_type': json['content_type'],
        'file_size_bytes': json['file_size_bytes'],
        'page_count': !exists(json, 'page_count') ? undefined : json['page_count'],
        'original_document_hash': !exists(json, 'original_document_hash') ? undefined : json['original_document_hash'],
    };
}

export function ReferralDocumentInputToJSON(value?: ReferralDocumentInput | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'document_id': value.document_id,
        'document_type': value.document_type,
        'file_name': value.file_name,
        's3_key': value.s3_key,
        'content_type': value.content_type,
        'file_size_bytes': value.file_size_bytes,
        'page_count': value.page_count,
        'original_document_hash': value.original_document_hash,
    };
}

